// Stroke icons carried over from the prototype so the main screen looks identical.
const PATHS = {
  headphones: 'M3 14v-3a9 9 0 0 1 18 0v3M3 13h3v7H3zM18 13h3v7h-3z',
  library: 'M4 4h4v16H4zM11 4h3v16h-3zM17 5l3-1 3 15-3 1z',
  heart: 'M20 5c-3-3-7-1-8 1-1-2-5-4-8-1-4 4 2 9 8 14 6-5 12-10 8-14z',
  globe: 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M3 12h18M12 3c-5 5-5 13 0 18 5-5 5-13 0-18',
  quote: 'M4 4h6v8c0 5-3 7-6 8v-4c2-1 3-2 3-4H4zM14 4h6v8c0 5-3 7-6 8v-4c2-1 3-2 3-4h-3z',
  bookmark: 'M6 3h12v18l-6-4-6 4z',
  spark: 'm12 2 3 7 7 3-7 3-3 7-3-7-7-3 7-3z',
  user: 'M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0M4 21v-2a8 8 0 0 1 16 0v2',
  play: 'm9 5 11 7-11 7z',
  pause: 'M8 5v14M16 5v14',
  back: 'M4 10a8 8 0 1 1 1 8M4 4v6h6',
  forward: 'M20 10a8 8 0 1 0-1 8M20 4v6h-6',
  close: 'm5 5 14 14M5 19 19 5',
  mic: 'M9 5a3 3 0 0 1 6 0v7a3 3 0 0 1-6 0zM5 10v2a7 7 0 0 0 14 0v-2M12 19v3M9 22h6',
  volume: 'm11 4-6 5H2v6h3l6 5zM15 8a6 6 0 0 1 0 8M18 4a11 11 0 0 1 0 16',
  check: 'm4 12 5 5L20 6',
  settings: 'M9 3h6l1 3 3 1 2 5-2 5-3 1-1 3H9l-1-3-3-1-2-5 2-5 3-1z M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
  book: 'M12 5C7 2 2 4 2 4v16s5-2 10 1c5-3 10-1 10-1V4s-5-2-10 1zm0 0v16',
  repeat: 'M4 7h13l-3-3m6 13H7l3 3M20 7v5M4 17v-5',
  clipboard: 'M9 4H5v17h14V4h-4M9 2h6v4H9zM8 10h1M12 10h4M8 15h1M12 15h4',
  folder: 'M3 6h6l2 2h10v11H3z',
  plus: 'M12 4v16M4 12h16',
  download: 'M12 3v12m-5-5 5 5 5-5M4 17v4h16v-4',
  trash: 'M3 6h18M9 6V3h6v3M6 6l1 15h10l1-15M10 10v7M14 10v7',
  link: 'M10 14a4 4 0 0 0 6 0l3-3a4 4 0 0 0-6-6l-1 1M14 10a4 4 0 0 0-6 0l-3 3a4 4 0 0 0 6 6l1-1',
  rss: 'M5 19a1 1 0 1 0 0-.1M4 11a9 9 0 0 1 9 9M4 4a16 16 0 0 1 16 16',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name }: { name: IconName }) {
  return (
    <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
      <path d={PATHS[name]} />
    </svg>
  );
}
